<template>
  <div style="padding-top: 30px;">
    <div >
      <div class="pdfTitle mb-4">請選擇報表種類</div>
      <div class="row">
        
        <div @click="$router.push({ name: 'policyHealthCheckPDF'})" class="col-4">
          <div class="custBorder">
            <strong  class="mt-0 d-flex justify-content-left font-20 mb-20">保單健檢規劃書</strong>
            <div>
              <!-- <strong class="mt-1 ml-4">111</strong> -->
              <!-- <span class="mt-1">111</span> -->
              <img class="img-responsive fit-image" :src="`${BaseUrl}assets/policyView.png`" />
            </div>
          </div>
        </div>
        <div @click="$router.push({ name: 'treasureFind'})" class="col-4 ">
          <div class="custBorder">
            <strong class="mt-0 d-flex justify-content-left font-20 mb-20">尋保圖(個人總覽)</strong>
            <div>
              <!-- <strong class="mt-1 ml-4">111</strong> -->
              <!-- <span class="mt-1">111</span> -->
              <img class="img-responsive fit-image" :src="`${BaseUrl}assets/MV_H00001_cover_background.png`"  />
            </div>
          </div>
        </div>
        <div @click="$router.push({ name: '321Img'})" class="col-4">
          <div class="custBorder">
            <strong class="mt-0 d-flex justify-content-left font-20 mb-20">321+1保藏圖</strong>
            <div>
              <!-- <strong class="mt-1 ml-4">111</strong> -->
              <!-- <span class="mt-1">111</span> -->
              <img class="img-responsive fit-image" :src="`${BaseUrl}assets/ICON_3211.png`" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";

import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import WarningModal from "@/desktop/components/WarningModal";
import NewGroup from "@/desktop/components/NewGroup";
import AddGroupModal from "@/desktop/components/AddGroupModal";

import { getAllFamily } from "@/service";

import { mapGetters } from "vuex";
import { getFamilyMemberBycondition,getAllHouseholderBySales } from "@/service";

import { log } from "util";

export default {
  name: "printPDF",
  mixins: [commonMixin],
  data() {
    return {
      //全選
      theadAll: false,
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      //前頁FAMILY DATA
      familyData: this.$store.state.userItems,
      //過濾有勾選
      familyResultFilter: [],
      //MOUNTED搜尋回傳結果
      getAllFamilyResult: [],
      remoteDataMessage: "資料讀取中，請稍候..."
    };
  },
  computed:{
   ...mapGetters(['BaseUrl'])
  },
  components: { Avatar },
  methods: {
    ...mapActions(["updateUserItems"]),
    moment
  },
  mounted() {
    this.$route.meta.reload = false;
  }
};
</script>
<style scoped>
.fit-image {
  width: 100%;
  object-fit: cover;
  /* height: 200px; only if you want fixed height */
}
.font-20 {
	font-size: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mr-22 {
    margin-right: 22px;
}
.custBorder  {
  flex: 1;
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #ffffff;
  padding: 20px;
  cursor: pointer;
}
.pdfTitle {
  width: 128px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}
</style>